import { render, staticRenderFns } from "./QuestionForm.vue?vue&type=template&id=7efd96ca&"
import script from "./QuestionForm.vue?vue&type=script&lang=ts&"
export * from "./QuestionForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports